<div class="summary-section">
  <h2 class="summary-title">{{ title() }}</h2>

  <div class="summary-content">
    <div class="summary-details">
      <!-- Mandatory -->
      <div class="summary-line">
        <span class="summary-label">Subtotal</span>
        <span class="summary-value">
          {{ subtotal() | price | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency() }}
        </span>
      </div>

      @if (showTax()) {
        <div class="summary-line">
          <span class="summary-label">Tax</span>
          <span class="summary-value">
            {{ tax() ?? 0 | price | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency() }}
          </span>
        </div>
      }

      @if (showShipping()) {
        <div class="summary-line">
          <span class="summary-label">Shipping</span>
          <span class="summary-value">
            {{ shipping() ?? 0 | price | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency() }}
          </span>
        </div>
      }

      @if (showFlatOrderFee()) {
        <div class="summary-line">
          <span class="summary-label">{{ flatOrderFeeLabel() || 'Handling fee' }}</span>
          <span class="summary-value">
            {{
              flatOrderFeeAmount() ?? 0
                | price
                | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency()
            }}
          </span>
        </div>
      }

      @if (showHandlingFee()) {
        <div class="summary-line">
          <span class="summary-label">Handling fee</span>
          <span class="summary-value">
            {{
              handlingFeeAmount() ?? 0
                | price
                | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency()
            }}
          </span>
        </div>
      }

      <div class="summary-line">
        <span class="summary-label">Total</span>
        <span class="summary-value">
          {{ preDiscountTotal() | price | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency() }}
        </span>
      </div>

      @if (showDiscount()) {
        <div class="summary-divider"></div>
        <div class="summary-line">
          <span class="summary-label">{{ 'SUMMARY.totalDiscountApplied' | translate }}</span>
          <span class="summary-value discount">
            -{{ discount() ?? 0 | price | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency() }}
          </span>
        </div>
      }

      <div class="summary-divider"></div>

      <!-- Mandatory -->
      @if (donation() > 0) {
        <div class="summary-line">
          <span class="summary-label">Donation</span>
          <span class="summary-value">
            {{ donation() | price | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency() }}
          </span>
        </div>
      }
      <div class="summary-line summary-total">
        <span class="summary-label">Total Due</span>
        <span class="summary-total-value">
          {{ totalDue() | price | usdPipe: 'USD' : 'symbol' : '1.2-2' : displayCurrency() }}
        </span>
      </div>
    </div>
  </div>
</div>
